import {DISPOSITIONS} from "models/options";
import {pipe} from "./misc";

/**
 * Get a Disposition definition object for a given disposition value or
 * "Unknown" object if dispositionValue is invalid.
 * @param {Number} dispositionValue
 * @returns {Object} Disposition object.
 */
export const getDispositionDef = (dispositionValue) =>
  pipe(getDispositionByValue, getDefaultDispositionDef)(dispositionValue);

/**
 * Get a Disposition definition object for a given disposition value.
 * @param {Number} dispositionValue
 * @returns {Object} Disposition object.
 */
export const getDispositionByValue = (dispositionValue) =>
  DISPOSITIONS.find((disposition) => disposition.value === dispositionValue);

export const getDispositionColor = (dispositionValue) =>
  pipe(getDispositionDef, (d) => d.color)(dispositionValue);

export const getDispositionName = (dispositionValue) =>
  pipe(getDispositionDef, (d) => d.title)(dispositionValue);

/**
 * @returns {Object} Unknown Disposition definition object.
 */
export const getUnknownDispositionDef = () =>
  DISPOSITIONS.find((disposition) => disposition.value === 5);

export const getDefaultDispositionDef = (dispositionDef) =>
  dispositionDef ? dispositionDef : getUnknownDispositionDef();
